<template>
  <div>
    <ul
      class="foot-bar"
      :class="{
        'customTheme': isCustomTheme === true,
        'enterFoot': isHeightFoot && jumpother
      }"
    >
      <li
        v-for="item in menus"
        :key="item.name"
        @click="handleClick(item)"
        :class="currentRouteName === item.name && 'active'"
      >
        <img
          v-if="item.icon"
          class="icon"
          :src="item.icon"
        >
        <p
          v-if="item.text"
          class="foot-text"
        >
          {{item.text}}
        </p>
        <img v-if="item.isDot && isDotInited" src="./imgs/one.png" class="one">
        <img v-if="item.showNewHot && showNewHotIcon" :src="newHotIcon" class="hot-icon-new">
      </li>
    </ul>
    <control-pad v-if="showPad" :isFooter="true"></control-pad>
    <div v-if="showBlock" class="mask-nosupport-interact" @click.stop="handleClickBlock">
      <div class="msgbox-wrapper">
        本KTV暂不支持该功能
      </div>
    </div>
  </div>
</template>

<script>
// TODO 有没有其他地方用了 游戏 等这样的硬编码名称
import { mapState } from 'vuex';
import cookie from '@/libs/utils/cookie';
import wx from 'weixin-js-sdk'
import { miniRoutes } from '@/libs/utils/consts'
import ControlPad from '@/components/app/play_control/control_pad';

export default {
  name: 'app-footer',
  props: {
    // 当前页，用以改变底部icon样式
    menus: Array,
  },
  components: {
    ControlPad,
  },
  computed: {
    ...mapState({
      showPad: (state) => state.showPad,
      is_bind: (state) => state.bind_status,
      is_vip: (state) => state.is_vip,
      isMinProgram: (state) => state.isMinProgram,
      isSupportInteract: (state) => state.isSupportInteract,
      giftPag: (state) => state.giftPag,
      user_img: (state) => state.user_img,
      isBlockInteractText: (state) => state.isBlockInteractText,
      appHistory: (state) => state.appHistory,
      $theme: (state) => state.$theme,
      role: (state) => state.role,
      bless_path: (state) => state.bless_path,
      photo_path_new: (state) => state.photo_path_new,
      photo_interact_path_new: (state) => state.photo_interact_path_new,
    }),
    userAvatar() {
      return this.user_img || 'https://qncweb-back1.ktvsky.com/20230411/vadd/e2e6e0d919b788783bb5fb47c2a5afb3.png'
    },
    currentRouteName() {
      if (this.showPad) {
        return 'playcontrol';
      }
      if (this.$route.name && (this.$route.name.includes('_pag') || this.$route.name.includes('_png'))) {
        return 'interact';
      }
      if (this.$route.name?.startsWith('HOME_')) {
        return 'home';
      }
      return this.$route.name;
    },
    isCustomTheme() {
      return this.menus.findIndex((item) => item.customTheme && this.$route.name === item.name) > -1
    },
    iconSuffix() {
      return this.isCustomTheme ? '-custom' : ''
    },
    miniHide() { // 小程序中为了绕过ios支付审核不通过，需要在未绑定房台时隐藏支付入口
      return this.isMinProgram && !this.is_bind
    },
    activeItem() {
      return this.menus.find((item) => item.name === this.$route.name) || {}
    },
    showBlock() {
      return this.isBlock || (this.activeItem?.isBlock && this.isBlockInteractText)
    },
    isHeightFoot() {
      return this.appHistory < 2 && /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812
    },
    isVipPag() {
      return this.is_vip && this.giftPag
    },
    newHotIcon() {
      return 'https://qncweb.ktvsky.com/20250627/vadd/e7022a68d87009a3d7cf87c7a428ab0b.png'
    }
  },
  data() {
    return {
      isDotInited: false,
      isBlock: false,
      canJumpInteract: false,
      jumpother: true,
      showNewHotIcon: false,
      autoHideTimer: null
    };
  },
  methods: {
    /**
     * 判断是否应该显示用户头像
     * @param {Object} item - 菜单项
     * @returns {boolean} 是否显示用户头像
     */
    shouldShowUserAvatar(item) {
      // 只有role3和role4用户在"我的"菜单项中显示头像
      console.log(['role3', 'role4'].includes(this.role))
      return ['role3', 'role4'].includes(this.role) && item.name === 'customer'
    },
    handleClickBlock() {
      // 当前页如果需要拦截，点击蒙层不能关闭
      // 如果在其他页点击跳转，点击蒙层可以关闭
      this.isBlock = this.activeItem.name === this.$route.name && this.activeItem.isBlock
    },
    initIsShowDot() {
      const targetMenuIndex = this.menus.findIndex((menu) => menu.name === this.$route.name);
      if (targetMenuIndex > -1) {
        this.menus[targetMenuIndex].isDot = false;
      }
      this.isDotInited = true;
    },
    handleClick(item) {
      if (item.name === 'playcontrol') { // 遥控按钮
        this.$sendLog({
          event_type: 'click',
          event_name: '遥控组件',
          event_data: {
            name: '遥控-底部导航',
          },
        });
        this.$store.commit('SET_CONTROL_PAD', !this.showPad);
        this.$store.commit('SHOW_BARRAGE', false)
        return
      }
      if (item.showNewHot) {
        this.showNewHotIcon = false
        clearTimeout(this.autoHideTimer)
        cookie.setCookie(1, 0.25, 'newHotShow');
      }
      this.$store.commit('SET_CONTROL_PAD', false);
      if (item.route === this.$route.path) return
      if (item.name === 'interact' && !this.isSupportInteract) {
        this.$toast('敬请期待～<br/>玩儿命开发中...')
        return
      }
      if (this.miniHide && item.name === 'customer') {
        this.$store.commit('SAVE_SHOW_SCODE_BOX', true);
        return
      }
      if (!this.is_bind && item.isForceBind) {
        this.$store.commit('SAVE_SHOW_SCODE_BOX', true);
        return
      }
      if (item.isDot) {
        item.isDot = false;
        cookie.setCookie(1, 0.25, 'isDotShow');
      }
      this.$sendLog({
        event_type: 'click',
        event_name: '底部导航栏',
        event_data: {
          name: item.name,
        },
      });
      if (this.isMinProgram) {
        wx.miniProgram.reLaunch({
          url: miniRoutes[item.route] || `/pages/webview/index?route=${item.route}`,
        })
        return
      }
      if (item.isBlock && this.isBlockInteractText) {
        this.isBlock = true
        return
      }
      this.jumpother = false
      if (item.name === 'interact' && !this.bless_path.includes('blessv1')) {
        return this.$router.push(`${this.photo_interact_path_new}?fromType=collection&isNewAnalytics=1`)
      }
      const route = item.hasFromType ? `${item.route}${item.route.includes('?') ? '&' : '?'}fromType=bottom` : item.route
      if (this.currentRouteName === item.name) return
      this.$router.push(route)
    },
    initNewHotShow() {
      const newHotShow = cookie.getCookie('newHotShow')
      if (!newHotShow) {
        this.showNewHotIcon = true
        // 3分钟后自动隐藏
        this.autoHideTimer = setTimeout(() => {
          this.showNewHotIcon = false
          cookie.setCookie(1, 0.25, 'newHotShow');
        }, 3 * 60 * 1000)
      }
    }
  },
  watch: {
    isBlockInteractText(val) {
      if (val) {
        const active = this.menus.filter((item) => item.name === this.$route.name && item.isBlock)
        if (active.length) {
          this.isBlock = true
        }
      }
    },
    $route(val) {
      const isDotShow = cookie.getCookie('isDotShow');
      if (val && val.name && val.meta.level === 1 && !isDotShow) {
        this.initIsShowDot();
      }
    },
  },
  mounted() {
    let enterKtvNums = cookie.getCookie('enterKtvNums') || 1;
    if (enterKtvNums < 3) {
      enterKtvNums++
      cookie.setCookie(enterKtvNums, 0.25, 'enterKtvNums');
    }

    this.initNewHotShow()
  },
  beforeDestroy() {
    if (this.autoHideTimer) {
      clearTimeout(this.autoHideTimer)
    }
  }
};
</script>

<style lang="scss" scoped>
.foot-bar {
  z-index: 999;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 112px;
  padding: 0 36px;
  @include background("footer-background");
  background-size: 100% 100%;
  box-shadow: 0 -4px 12px 0 rgba(0,0,0,0.04);
  li {
    width: 112px;
    height: 112px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    position: relative;
    .one {
      width: 32px;
      height: 33px;
      border-radius: 50%;
      position: absolute;
      right: 8px;
      top: 5px;
    }
  }
  li:nth-child(3) {
    img {
      width: 106px;
      height: 106px;
      margin-top: 3px;
    }
  }
  .foot-text {
    width: 100%;
    font-weight: 600;
    font-size: 32px;
    color: #999999;
    white-space: nowrap;
    line-height: 112px;
    text-align: center;
  }
  .bounce {
    width: 250px;
    position: absolute;
    top: -69px;
    left: -70px;
    z-index: 2;
    animation: bounce 0.5s infinite;
  }
  .noread{
    position: absolute;
    width: 134px;
    top: -60px;
    left: -30px;
  }
  .border {
    width: 64px;
    height: 64px;
    @include flexCenter();
    border-radius: 50%;
    border: 2px solid #D9D9D9;
    &.active {
      border-color: #8B76F6;
    }
    img {
      width: 56px;
      height: 56px;
      border-radius: 50%;
    }
  }
  .active {
    .foot-text {
      color: #000000;
    }
  }
}

.customTheme {
  background:linear-gradient(180deg, #FFE8B5, #FCBC6C);
    .foot-text {
      color: #E59C3D;
      &.active {
        color: #FF0B23;
      }
    }
  }
.hot-icon-new {
  width: 86px;
  height: 51px;
  position: absolute;
  right: 10px;
  top: -20px;
}
::v-deep .free-icon {
  position: absolute;
  padding: 5px 10px;
  background: #FF0B23;
  right: -10px;
  top: -5px;
  color: #fff;
  font-size: 18px;
  border-radius: 15px;
}
@keyframes bounce {
  0% {
    transform: translateY(0%);
  }
  50% {
    transform: translateY(-30%);
  }
  100% {
    transform: translateY(0%);
  }
}
.enterFoot{
  height: 150px;
}
</style>
